const SupplierListCertificatesView = ({ supplier }) => {
  const certificateItems = supplier.certificates
    ? Object.entries(JSON.parse(supplier.certificates)).filter(
        ([name, url]) => !!name && !!url,
      )
    : [];

  return (
    <div className="min-w-[200px]">
      {certificateItems.length > 0 ? (
        certificateItems.map(([name, url], index) => (
          <span key={`${name}-${index}`}>
            {name}
            {index < certificateItems.length - 1 ? ", " : ""}
          </span>
        ))
      ) : (
        <span className="opacity-50">-</span>
      )}
    </div>
  );
};

export default SupplierListCertificatesView;
